import { GridAction } from '@eforall/dashboard';
import { ProgressBySection } from '../progress-by-section-view.part';

export function getActions() {

	const actions: GridAction<ProgressBySection>[] = [];

	return actions;
}